module.exports = __webpack_public_path__ + "static/eu@2x-958c7eb0e76fab4bbfb9e010c5748ab3.png";